import Vue from 'vue';
/**
 * @module Store/accountTerms
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {Object}
 * */
const state = {
    locales: ['de', 'en', 'it', 'fr', 'nl', 'no', 'hu', 'sv'],
    userDocuments: [],
};

/**
 * @constant Getters
 * @type {Object}
 * */
const getters = {
    getLocales: state => state.locales,
    getLocalesWithLabels: state => {
        return state.locales.map(locale => {
            return { label: locale.toUpperCase(), value: locale}
        })
    },
    getUserDocuments: state => state.userDocuments,
};

/**
 * @constant Mutations
 * @type {Object}
 * */
const mutations = {
    setLocale: (state, payload) => state.locales = payload,
    setUserDocuments: (state, payload) => state.userDocuments = payload,
};

/**
 * @constant Actions
 * @type {Object}
 * */
const actions = {
    async getLocalesAsync ({commit, dispatch}) { 
        try {
            let {data} =  await Vue.axios.get('/utilities');
            commit('setLocale', data)
            return {data};
        } catch (err) {
            throw new Error(err);
        }
    },
    async getDefaultLanguage ({commit, dispatch}, {document, language}) { 
        try {
            let {data} =  await Vue.axios.get(`/utilities/legal/${document}?lang=${language}`);
            return {data};
        } catch (err) {
            throw new Error(err);
        }
    },
    async setDocument ({commit, dispatch}, payload) { 
        try {
            let {data} =  await Vue.axios.post(`/collecter/classes/translations`, payload, {
                headers: {
                    'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'
                }
            });
            dispatch('getUserDocumentsAsync')
            commit('addAlert', {
                title: 'Success ',
                type: 'success',
                body: 'to set document'
            });
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to set document'
            });
            throw new Error(err);
        }
    },
    async updateDocument ({commit, dispatch}, payload) { 
        try {
            let {data} =  await Vue.axios.put(`/collecter/classes/translations/${payload.objectId}`, payload, {
                headers: {
                    'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'
                }
            });
            dispatch('getUserDocumentsAsync')
            commit('addAlert', {
                title: 'Success ',
                type: 'success',
                body: 'to update document'
            });
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to update document'
            });
            throw new Error(err);
        }
    },
    async deleteDocumentAsync ({commit, dispatch}, payload) { 
        try {
            let {data} =  await Vue.axios.delete(`/collecter/classes/translations/${payload.objectId}`, {
                headers: {
                    'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'
                }
            });
            dispatch('getUserDocumentsAsync')
            commit('addAlert', {
                title: 'Success ',
                type: 'success',
                body: 'to delete document'
            });
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to delete document'
            });
            throw new Error(err);
        }
    },
    async getUserDocumentsAsync({commit, dispatch, getters}){
        try {
            let {data: {results}} = await Vue.axios.get('/collecter/classes/translations', {
                params: { where: { account: getters.getUserId }},
                headers: {'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8'}
            });
            commit('setUserDocuments', results)
            return results;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to load user documents'
            });
            throw error
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
